import { cx } from "class-variance-authority";
import React from "react";

import * as styles from "./Box.module.scss";

type BoxProps = {
  children?: React.ReactNode;
  icon?: React.ReactNode;
  title?: React.ReactNode | string;
  subTitle?: React.ReactNode | string;
  clamp?: React.ReactNode;
  className?: string;
  clampClassName?: string;
  childrenClassName?: string;
  headerContentClassName?: string;
  hideHeader?: boolean;
  noChildrenSpace?: boolean;
  onClick?: () => void;
  hasPadding?: boolean;
  headerChildren?: React.ReactNode;
  wrapSubtitle?: boolean;
};

const Box = ({
  children,
  icon,
  title,
  subTitle,
  clamp,
  className,
  clampClassName,
  childrenClassName,
  headerContentClassName,
  hideHeader = false,
  noChildrenSpace = false,
  onClick,
  hasPadding = true,
  headerChildren,
  wrapSubtitle = false,
}: BoxProps) => {
  return (
    <div
      className={cx(
        styles.box,
        {
          [styles.hasChildren]: !!children && !noChildrenSpace,
          [styles.hasPadding]: hasPadding,
        },
        className,
      )}
      onClick={onClick}
    >
      {!hideHeader && (
        <div className={styles.header}>
          {icon && <div className={styles.icon}>{icon}</div>}
          <div className={cx(styles.clamp, clampClassName)}>{clamp}</div>
          <div
            className={cx(
              styles.titleAndSubtitleWithChildren,
              headerContentClassName,
            )}
          >
            <div className={styles.titleAndSubtitle}>
              <span className={styles.title}>{title}</span>
              <div
                className={cx(styles.subtitle, {
                  [styles.wrapSubtitle]: wrapSubtitle,
                })}
              >
                {subTitle}
              </div>
            </div>

            {headerChildren ? (
              <div className={styles.headerChildren}>{headerChildren}</div>
            ) : null}
          </div>
        </div>
      )}
      {children && <div className={childrenClassName}>{children}</div>}
    </div>
  );
};

export { Box };